// https://wiki.tigerbrokers.net/pages/viewpage.action?pageId=34636717 账户状态/权限 @黄翀
export const HOST = [
    'https://tesseract-dev.ihuhoo.com',
    'https://tesseract.tradeup.com',
    'https://ams-auth-us-qa.tigerbrokers.net/tesseract'
];
export const API = {
    userStatus: '/api/v2/account/status', // 用户状态 新接口
    tradePermission: '/api/v1/account/permission' // 账户权限
};

// 使用cg返回的数据，如果有牌照或者region等多种域名区分，需要在这里逐一展开
export function bindCG() {
    const cfg = CG_API.tesseract?.TBUS;

    cfg && HOST.fill(cfg);
}
